
import axios from "@/services/axios";
import Galleria from "primevue/galleria";
import { defineComponent, onMounted, reactive, inject, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import ResearchEquipmentDetailDto from "../research-equipment-detail-dto";
import UserRepositoryAPI from "@/modules/user/user-repository-api";
import ResearchEquipmentRepositoryAPI from "@/modules/research-equipment/research-equipment-repository-api";
import { useI18n } from "vue-i18n";
import { location } from "@/utils/default-data";
import { getCategoryLanguageName } from "@/locales/i18n";
import DateFormatingService from "@/modules/dateFormatingService";

interface ResponsibleUserContactView {
  name: string;
  email: string;
  mobile: string;
}

export default defineComponent({
  components: {
    Galleria,
  },
  props: {
    id1: {
      type: String,
      default: "",
    },
    id2: {
      type: String,
      default: "",
    },
    class: {
      type: String,
      default: "productFull",
    },
  },
  setup(props) {
    const { t } = useI18n();
    const route = useRoute();
    const { formatDate } = DateFormatingService();
    const localProperty = getCategoryLanguageName();
    let id1 = route.params.id1 as string;
    if (props.id1 != "") {
      id1 = props.id1 as string;
    }
    let id2 = route.params.id2 as string;
    if (props.id2 != "") {
      id2 = props.id2 as string;
    }

    const keycloak = inject("keycloak") as Keycloak.KeycloakInstance;
    const { getAuth } = UserRepositoryAPI();
    const { setResearchEquipment } = ResearchEquipmentRepositoryAPI();
    const router = useRouter();

    const state = reactive({
      localProperty: localProperty,
      responsibleUserContact1: {} as ResponsibleUserContactView,
      responsibleUserContact2: {} as ResponsibleUserContactView,
      item1: {} as ResearchEquipmentDetailDto,
      item2: {} as ResearchEquipmentDetailDto,
      images1: [] as Array<string>,
      images2: [] as Array<string>,
      id1: "",
      id2: "",
      showGallery1: false,
      showGallery2: false,
      productImage1: "",
      productImage2: "",
      showLoginDialog: false,
      showRegistrationDialog: false,
    });
    const getDetailData1 = (id: string) => {
      if (id) {
        axios.get(`api/v1/ResearchEquipment/${id}/detail`).then((response) => {
          state.item1 = response.data as ResearchEquipmentDetailDto;
          state.id1 = response.data.id;
          state.responsibleUserContact1 = mapResponsibleUserContactView(
            response.data.contactUsers
          );
        });
      }
    };

    const getDetailData2 = (id: string) => {
      if (id) {
        axios.get(`api/v1/ResearchEquipment/${id}/detail`).then((response) => {
          state.item2 = response.data as ResearchEquipmentDetailDto;
          state.id2 = response.data.id;
          state.responsibleUserContact2 = mapResponsibleUserContactView(
            response.data.contactUsers
          );
        });
      }
    };

    async function getEquipmentImages1(id: string) {
      state.images1 = [];
      state.productImage1 = "";
      if (id) {
        axios.get(`api/v1/ResearchEquipment/${id}/images`).then((response) => {
          state.images1 = response.data;
          if (response.data.length > 0) {
            state.productImage1 = response.data[0].url;
          }
        });
      }
    }
    async function getEquipmentImages2(id: string) {
      state.images2 = [];
      state.productImage2 = "";
      if (id) {
        axios.get(`api/v1/ResearchEquipment/${id}/images`).then((response) => {
          state.images2 = response.data;
          if (response.data.length > 0) {
            state.productImage2 = response.data[0].url;
          }
        });
      }
    }

    const onBookEquipmentClick = (item: any): void => {
      const isAuthenticated = getAuth.value.isAuthenticated as boolean;
      if (!isAuthenticated) {
        state.showLoginDialog = true;
        return;
      }
      setResearchEquipment(item);
      router.push({
        name: "user-bookings",
        params: { id: getAuth.value.uuid },
      });
    };

    const onLoginRedirectClick = (): void => {
      state.showLoginDialog = false;
      keycloak.login({ redirectUri: window.location.href });
    };

    onMounted(() => {
      getDetailData1(id1);
      getDetailData2(id2);
      getEquipmentImages1(id1);
      getEquipmentImages2(id2);
    });

    watch(
      () => props.id1,
      (newValue) => {
        getDetailData1(newValue);
        getEquipmentImages1(newValue);
      }
    );
    watch(
      () => props.id2,
      (newValue) => {
        getDetailData2(newValue);
        getEquipmentImages2(newValue);
      }
    );

    const locationPosition1 = (): any => {
      return {
        lat: state.item1?.location?.latitude || location.lat,
        lng: state.item1?.location?.longitude || location.lng,
      };
    };

    const locationPosition2 = (): any => {
      return {
        lat: state.item2?.location?.latitude || location.lat,
        lng: state.item2?.location?.longitude || location.lng,
      };
    };

    function mapResponsibleUserContactView(
      contactUsers: any
    ): ResponsibleUserContactView {
      const user = contactUsers.find((item: any) => item.email != "");
      return {
        name: `${user.firstname} ${user.lastname}`,
        email: user.email,
        mobile: user.phoneNumber,
      } as ResponsibleUserContactView;
    }

    return {
      t,
      state,
      locationPosition1,
      locationPosition2,
      onBookEquipmentClick,
      formatDate,
      onLoginRedirectClick,
    };
  },
});
